<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-05-19 09:49:33
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-02-11 10:13:04
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { checkMaintenance } from "@/utils/maintenance";

export default {
  name: "App",
  created() {
    checkMaintenance();
  },
};
</script>

<style lang="scss">
@import "scss/variable";
body .el-table::before {
  z-index: inherit;
}
// 主题色
$ui-color-black: #000;
$color-grey: #969799;
$color-red: #ee0a24;
$color-black: #000;
$color-theme: #155bd4;

$font-mini: 12px;
$font-middle: 14px;
$font-large: 16px;

$h5-color-theme: #c7655a;
$h5-color-bg: #f8f8f8;

.grey {
  color: $color-grey;
}

.drawer__header {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}

.drawer__headerSpan {
  border-right: 4px solid #155bd4;
  margin-right: 10px;
  border-radius: 10px;
  position: relative;
}

.drawer {
  padding-left: 50px;
  background: transparent; // 使用 transparent 替代 none 更具语义性
  box-shadow: none; // 只保留标准写法，去掉 -webkit 前缀
  min-width: 1000px !important; // 如果这个属性确实需要 !important，保留它
}

.drawer__body {
  padding: 25px;
  background-color: #fff;
  overflow-y: auto;
}

.drawer__footer {
  text-align: center;
  padding: 8px 0px;
  width: 100%;
}

.avue-crud__pagination {
  position: relative;
  padding: 25px 0 20px 20px;
  text-align: right;
}
</style>
